export const primaryColor = '#A02279';

export const bgColor = 'linear-gradient(90deg, #A02279 11.45%, #A02279 11.45%)';
